export default "__VITE_ASSET__pLhid3d$elTFKdZ4iiTEbA__"